import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

class CardExterno extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { children } = this.props;

    return (
      <div className="mt-2">
        <Card>
          <CardContent>{children}</CardContent>
        </Card>
      </div>
    );
  }
}

export default CardExterno;
